import { MenuItem } from "primereact/menuitem";

export function getVisibleMenu(panelMenuItems: MenuItem[]) {
  const filteredMenu = panelMenuItems.filter(item => !!item);
  const visiblePanels = filteredMenu.map((menuItem: MenuItem) => {
    const childrenMenuItems = (menuItem.items || []) as MenuItem[];
    const visibleChildrenItems = childrenMenuItems.filter(
      (childItem: MenuItem) => !childItem.data?.isHidden
    ) as MenuItem[];
    const filteredMenuItem = {
      ...menuItem,
      items: visibleChildrenItems,
    } as MenuItem;

    return filteredMenuItem;
  });

  const filteredPanels = visiblePanels.filter((item) => !item.data?.isHidden);

  return filteredPanels;
}
